<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text Products for item {{ slotNumber }}

        v-card-text.pa-0
          div.pa-4.d-flex.align-center
            div.p2 Rearrange your products  
            v-spacer
            v-btn(depressed small color="success500" :loading="isLoading" @click="save")
              .button-AA-tiny.white--text Save
          
          v-container.px-1.py-0(style="max-width:600px")
            .contain-layout
              draggable.my-2(tag="div" handle=".handle" :list="products" @start="drag=true" @end="endMove")
                div(v-for="(product, productIndex) in products")
                  v-card(v-if="product.view" flat)
                    v-row(no-gutters)
                      v-col.shrink
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
                      v-col.py-2.px-2
                        div.p1.basic800--text.mb-1(v-if="$vuetify.breakpoint.xs") {{ product.name | truncate(27) }}
                        div.p1.basic800--text.mb-1(v-else) {{ product.name | truncate(65) }}
                        div.c1.basic600--text.product-price.mb-1 {{ product.price | displayPrice }}
                        v-chip.c2.primary500--text.my-auto(v-if="product.options.length > 0" x-small style="border: 1px solid var(--v-primary500)") {{ product.options.length === 1 ? 'Variants' : 'Multivariants' }}
                      v-col.shrink.align-self-center.pa-4.handle(:class="{ 'drag-active': drag }")
                        ArrowsSortIcon.mx-1.mb-n1(size="20" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                    v-divider.basic300(v-if="productIndex !== products.length-1")

</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'ArrangeProductsBundle',
  components: {
    draggable
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentProducts: {
      type: Array,
      required: true
    },
    slotNumber: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      products: [],
      isLoading: false,
      drag: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted() {
    this.products = [...this.parentProducts]
  },
  methods: {
    endMove () {
      this.drag = false
    },
    save() {
      this.isLoading = true
      this.$emit('updateData', this.products)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
</style>